module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.hasVersions) ? _c('span', {
    staticClass: "pull-right history",
    on: {
      "click": function($event) {
        _vm.showHistory = !_vm.showHistory
      }
    }
  }, [_vm._v("\n    Alterado " + _vm._s(_vm.hasVersions) + " vez"), (_vm.hasVersions > 1) ? _c('span', [_vm._v("es")]) : _vm._e(), _vm._v(".\n\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.versions), function(version) {
    return _c('div', [(version.type == 'text' || version.type == 'textarea' || version.type == 'cpf' || version.type == 'cnpj' || version.type == 'phone') ? _c('span', [_vm._v("\n      " + _vm._s(version.stringField) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'computed') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.compute(version.stringField, _vm.fields.filter(function (f) { return !f.newerVersion && _vm.isSameSection(f, _vm.sectionOrder + 1, _vm.sectionId); }))) + " "), _c('span', {
      staticClass: "pull-right",
      staticStyle: {
        "color": "gray"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-info-sign",
      attrs: {
        "title": version.stringField
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v("Computado automaticamente")])])]) : _vm._e(), _vm._v(" "), (version.type == 'date' && version.dateField) ? _c('span', [_c('span', {
      staticClass: "glyphicon glyphicon-calendar"
    }), _vm._v(" " + _vm._s(new Date(version.dateField.iso).toLocaleString('pt-BR')) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'number') ? _c('span', [_vm._v("\n      " + _vm._s(version.numField) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'money') ? _c('span', [_vm._v("\n      " + _vm._s(version.numField) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'checkbox') ? _c('span', [_c('ul', {
      staticClass: "list-inline"
    }, _vm._l((version.checkboxField), function(option) {
      return _c('li', [_c('span', {
        staticClass: "glyphicon glyphicon-ok"
      }), _vm._v("\n        " + _vm._s(option.name))])
    }), 0)]) : _vm._e(), _vm._v(" "), (version.type == 'link') ? _c('a', {
      attrs: {
        "href": version.stringField,
        "target": "_blank"
      }
    }, [(version.stringField) ? _c('span', {
      staticClass: "glyphicon glyphicon-new-window"
    }) : _vm._e(), _vm._v("\n      " + _vm._s(version.stringField) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'file') ? _c('span', [(!version.fileField) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Nenhum arquivo anexado.")]) : _c('div', [_c('span', {
      staticClass: "glyphicon glyphicon-paperclip"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": version.fileField.url,
        "target": "_blank"
      }
    }, [_vm._v("Visualizar")])])]) : _vm._e(), _vm._v(" "), (version.type == 'document') ? _c('span', [(!version.fileField) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Nenhum arquivo anexado.")]) : _c('div', [_c('span', {
      staticClass: "glyphicon glyphicon-paperclip"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": version.fileField.url,
        "target": "_blank"
      }
    }, [_vm._v("Visualizar")])])]) : _vm._e(), _vm._v(" "), (version.type === 'select' && version.selectField) ? _c('span', [_vm._v("\n      " + _vm._s(version.selectField.name) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showHistory) ? _c('span', [_vm._v("por "), _c('span', {
      staticClass: "version-owner"
    }, [_vm._v(_vm._s(version.owner.username))]), _vm._v(" "), _c('span', {
      staticClass: "version-date"
    }, [_vm._v(_vm._s(_vm.formatDate(version.createdAt)))])]) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49eeac3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/DynamicViewField.vue
// module id = 1446
// module chunks = 1